import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Android16 = ({
  height = 16,
  width = 16,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.9375 14.5642H4.0625C3.83044 14.5642 3.60788 14.472 3.44378 14.3079C3.27969 14.1438 3.1875 13.9213 3.1875 13.6892V7.56421H12.8125V13.6892C12.8125 13.9213 12.7203 14.1438 12.5562 14.3079C12.3921 14.472 12.1696 14.5642 11.9375 14.5642Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8125 7.125C12.8125 5.84865 12.3055 4.62457 11.403 3.72205C10.5004 2.81953 9.27635 2.3125 8 2.3125C6.72365 2.3125 5.49957 2.81953 4.59705 3.72205C3.69453 4.62457 3.1875 5.84865 3.1875 7.125V7.5625H12.8125V7.125Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.03125 4.93921C6.07451 4.93921 6.11681 4.95204 6.15278 4.97608C6.18875 5.00011 6.21679 5.03428 6.23335 5.07425C6.24991 5.11422 6.25424 5.1582 6.2458 5.20064C6.23736 5.24307 6.21652 5.28205 6.18593 5.31264C6.15534 5.34323 6.11636 5.36407 6.07393 5.37251C6.03149 5.38095 5.98751 5.37661 5.94754 5.36006C5.90757 5.3435 5.8734 5.31546 5.84937 5.27949C5.82533 5.24352 5.8125 5.20122 5.8125 5.15796C5.8125 5.09994 5.83555 5.0443 5.87657 5.00328C5.91759 4.96226 5.97323 4.93921 6.03125 4.93921"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.96875 4.93921C10.012 4.93921 10.0543 4.95204 10.0903 4.97608C10.1263 5.00011 10.1543 5.03428 10.1708 5.07425C10.1874 5.11422 10.1917 5.1582 10.1833 5.20064C10.1749 5.24307 10.154 5.28205 10.1234 5.31264C10.0928 5.34323 10.0539 5.36407 10.0114 5.37251C9.96899 5.38095 9.92501 5.37661 9.88504 5.36006C9.84507 5.3435 9.8109 5.31546 9.78687 5.27949C9.76283 5.24352 9.75 5.20122 9.75 5.15796C9.75 5.09994 9.77305 5.0443 9.81407 5.00328C9.85509 4.96226 9.91073 4.93921 9.96875 4.93921"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.29275 3.14779L4.0625 1.43921"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7073 3.14779L11.9375 1.43921"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.1875 7.56421C2.72337 7.56421 2.27825 7.74858 1.95006 8.07677C1.62187 8.40496 1.4375 8.85008 1.4375 9.31421V12.8142"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8125 7.56421C13.2766 7.56421 13.7217 7.74858 14.0499 8.07677C14.3781 8.40496 14.5625 8.85008 14.5625 9.31421V12.8142"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
